import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteLesson } from "../../../api/endpoints/LessonEndpoints";

export default function useDeleteLesson() {
  return useMutation<void, AxiosError, { lessonId: string }>({
    mutationKey: ["delete-lesson"],
    mutationFn: ({ lessonId }) => deleteLesson(lessonId),
  });
}
